// src/hooks/useListingTransfer.js


import { useState, useCallback } from 'react';
import { getAuth } from 'firebase/auth';
import app from '../firebase';

export function useListingTransfer({
  apiBase = process.env.REACT_APP_API_TRANSFER,
} = {}) {
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);

  const transferListings = useCallback(async (recipientEmail, listingIds, idempotencyKey) => {
    setLoading(true);
    setError(null);
    try {
      const auth = getAuth(app);
      const fbUser = auth.currentUser;
      if (!fbUser) throw new Error('Not authenticated');
      const token = await fbUser.getIdToken();

      const res = await fetch(`${apiBase}/api/transfers/listings`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ recipientEmail, listingIds, idempotencyKey }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Transfer failed');

      return { ...data, count: data?.counts?.transferred ?? 0 };
    } catch (e) {
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, [apiBase]);

  return { transferListings, loading, error };
}

// import { useState, useCallback } from 'react';
// import {
//   getFirestore,
//   collection,
//   query,
//   where,
//   getDocs,
//   limit,
//   writeBatch,
//   doc,
//   serverTimestamp,
// } from 'firebase/firestore';
// import app from '../firebase';
// import { useAuth } from './useAuth';

// const db = getFirestore(app);

// const emailOk = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(e || '').trim().toLowerCase());

// async function resolveUidByEmail(emailRaw) {
//   const email = String(emailRaw || '').trim().toLowerCase();
//   if (!emailOk(email)) throw new Error('Invalid email');
//   const q = query(collection(db, 'users'), where('email', '==', email), limit(1));
//   const snap = await getDocs(q);
//   if (snap.empty) throw new Error('User not found');
//   const d = snap.docs[0];
//   return { uid: d.id, profile: d.data() };
// }

// export function useListingTransfer({ listingCollection = 'listings', ownerField = 'ownerUid' } = {}) {
//   const { currentUser } = useAuth(); // expect currentUser.uid to be the account/owner UID (your existing pattern)
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const transferListings = useCallback(
//     async (recipientEmail, listingIds = []) => {
//       setLoading(true);
//       setError(null);
//       try {
//         if (!currentUser?.uid) throw new Error('Not authenticated');
//         const fromUid = currentUser.uid;
//         const ids = Array.isArray(listingIds) ? listingIds.filter(Boolean) : [];
//         if (ids.length === 0) throw new Error('No listing IDs provided');

//         // 1) Resolve recipient UID
//         const { uid: toUid } = await resolveUidByEmail(recipientEmail);

//         // 2) Batch update listings (chunk by 450 to stay under 500 ops)
//         const chunkSize = 450;
//         for (let i = 0; i < ids.length; i += chunkSize) {
//           const chunk = ids.slice(i, i + chunkSize);
//           const batch = writeBatch(db);
//           chunk.forEach((listingId) => {
//             const ref = doc(db, listingCollection, listingId);
//             batch.set(
//               ref,
//               {
//                 [ownerField]: toUid,
//                 updatedAt: serverTimestamp(),
//                 // audit fields (optional but recommended)
//                 transfer: {
//                   from: fromUid,
//                   to: toUid,
//                   at: serverTimestamp(),
//                 },
//               },
//               { merge: true }
//             );
//           });
//           await batch.commit();
//         }

//         // 3) Optional global audit log
//         const logRef = doc(collection(db, 'listingTransfers'));
//         const logBatch = writeBatch(db);
//         logBatch.set(logRef, {
//           from: fromUid,
//           to: toUid,
//           listingIds: ids,
//           count: ids.length,
//           createdAt: serverTimestamp(),
//         });
//         await logBatch.commit();

//         return { toUid, count: ids.length };
//       } catch (e) {
//         setError(e);
//         throw e;
//       } finally {
//         setLoading(false);
//       }
//     },
//     [currentUser, listingCollection, ownerField]
//   );

//   return { transferListings, loading, error };
// }
